import { useMutation } from '@tanstack/react-query';
import api from '../lib/axios';

export function useSeoCheck() {
  return useMutation({
    mutationFn: async ({ url, skipPagespeed = false }) => {
      const { data } = await api.post(
        '/seo-check',
        { url, skip_pagespeed: skipPagespeed },
        { skipProject: true, timeout: 120000 },
      );
      return data;
    },
  });
}
